<ng-template #header>
    <shared-header [center]="true" [brandAccent]="true" type="5" marginTop="md" marginBottom="none"
        class="modal-for-delivery-address__sub-h">
        DELIVERY ORDER
    </shared-header>

    <shared-header [center]="true" class="modal-for-delivery-address__h" type="3" marginTop="none" marginBottom="none">
        Set your delivery address
    </shared-header>

    <shared-text class="modal-for-delivery-address__desc" [brandAccent]="false" [dimmed]="true" weight="300">
        Enter your address and we will confirm If delivery
        <br />
        Is available for this location
    </shared-text>

</ng-template>

<shared-modal-type-dynamic-height [header]="header" [footer]="footer" [headerBorderBottom]="false"
    [modalData]="modalData" [center]="true" [footerBorder]="true" [mobilePreserve]="true" [size]="size"
    (onScrollInit)="handleScrollInit($event)" (onCloseClick)="handleCloseClick($event)"
    class="modal-for-delivery-address">

    <shared-form-for-address [labelAddress]="null" [detachFormSubmitControls]="true" (onInit)="handleFormInit($event)"
        (onSelected)="handleAddressSelected($event)" class="modal-for-delivery-address__form">
    </shared-form-for-address>

</shared-modal-type-dynamic-height>



<ng-template #footer>
    <div class="modal-for-delivery-address__ft">
        <shared-btn width="extended" size="xlg" type="button" [emphasis]="false"
            (onClick)="handleCheckAddressClick($event)" [disabled]="!isFormValid">
            Check address
        </shared-btn>
    </div>
</ng-template>